import { render, staticRenderFns } from "./my-order-details.vue?vue&type=template&id=0174b623&"
import script from "./my-order-details.vue?vue&type=script&lang=js&"
export * from "./my-order-details.vue?vue&type=script&lang=js&"
import style0 from "./my-order-details.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports